import { useCallback, useRef } from 'react';
import classNames from 'classnames';
import { CUSTOMIZED_TABLE_CONFIG } from './CustomizableTable';

export const ResizableHeaderCell: React.FC<any> = props => {
    const { width, onResize, children, ...rest } = props;

    const startXRef = useRef<number | null>(null);
    const startWidthRef = useRef<number | null>(null);

    const handleMouseDown = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();

        startXRef.current = e.clientX;
        startWidthRef.current = width;

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };

    const handleMouseMove = useCallback(
        (e: MouseEvent) => {
            if (startXRef.current !== null && startWidthRef.current !== null) {
                let newWidth = startWidthRef.current + (e.clientX - startXRef.current);

                if (newWidth < CUSTOMIZED_TABLE_CONFIG.minColumnWidth) newWidth = CUSTOMIZED_TABLE_CONFIG.minColumnWidth;
                if (newWidth > CUSTOMIZED_TABLE_CONFIG.maxColumnWidth) newWidth = CUSTOMIZED_TABLE_CONFIG.maxColumnWidth;

                if (onResize) onResize(newWidth);
            }
        },
        [onResize]
    );

    const handleMouseUp = useCallback(() => {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);

        startXRef.current = null;
        startWidthRef.current = null;
    }, [handleMouseMove]);

    return (
        <th
            {...rest}
            style={{
                ...props.style,
                minWidth: CUSTOMIZED_TABLE_CONFIG.minColumnWidth,
                maxWidth: CUSTOMIZED_TABLE_CONFIG.maxColumnWidth,
                width,
            }}
            className={classNames('custom-table-header-cell', rest.className)}
        >
            <div className="custom-table-header-content">{children}</div>
            {onResize && (
                <span
                    className="custom-table-resizer"
                    onMouseDown={handleMouseDown}
                    onClick={e => {
                        e.stopPropagation();
                        e.preventDefault();
                    }}
                />
            )}
        </th>
    );
};
